import React from 'react';
import BillingsLayout from './BillingsLayout';
import {EmptyState, Loader, TableLayout} from 'components';
import {useGatedQuery} from '../../FraudDetection/Flows/hooks/useGatedQuery';
import {fetchPaymentTransactions} from '../../../requests/queries/flows';
import {formatNumberToCurrency} from '../../../helpers/formatNumberToCurrency';
import {getStatusTextAndStyles} from '../../../helpers/getStatusTextAndStyles';
import moment from 'moment';

function ProfiledRiskBillings() {
  const {data: transactionsData, isLoading} = useGatedQuery(
    'company-billing-transactions',
    fetchPaymentTransactions,
  );

  return (
    <BillingsLayout>
      <div className="mt-6">
        <TableLayout className="!px-8">
          <thead className="text-xs font-semibold uppercase">
            <tr className="bg-white80">
              <th className="p-5 pl-4 sm:pl-4 xl:pl-4 font-medium text-left text-xs text-grey whitespace-nowrap">
                Amount
              </th>
              <th className="p-5 pl-0 font-medium text-left text-xs text-grey whitespace-nowrap">
                Vat
              </th>
              <th className="p-5 pl-0 font-medium text-left text-xs text-grey whitespace-nowrap">
                Total Amount
              </th>
              <th className="p-5 pl-0 font-medium text-left text-xs text-grey whitespace-nowrap">
                Reference Number
              </th>{' '}
              <th className="p-5 pl-0 font-medium text-left text-xs text-grey whitespace-nowrap">
                Status
              </th>
              <th className="p-5 pl-0 font-medium text-left text-xs text-grey whitespace-nowrap">
                Date Created
              </th>
              <th className="p-5 pl-0 font-medium text-left text-xs text-grey whitespace-nowrap">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td colSpan={8}>
                {isLoading ? (
                  <Loader height={25} />
                ) : !isLoading && transactionsData?.length === 0 ? (
                  <EmptyState
                    body="You don't have any profiles yet, create a flow to get started"
                    height={25}
                    bodyMaxWidth="max-w-[278px]"
                    noBtn
                  />
                ) : null}
              </td>
            </tr>
          </tbody>

          <tbody className="text-sm">
            {transactionsData?.map(transaction => (
              <tr
                key={transaction.id}
                className="border-b border-[#F6F7F9] hover:bg-white80"
              >
                <td className="p-4 pl-4 sm:pl-4 xl:pl-4 text-tiny text-body">
                  {formatNumberToCurrency(
                    transaction?.amount || 0,
                    transaction?.currency,
                  )}
                </td>
                <td className="p-4 pl-0">
                  {formatNumberToCurrency(
                    transaction?.vat || 0,
                    transaction?.currency,
                  )}
                </td>
                <td className="min-w-[100px]">-</td>
                <td className="min-w-[100px]">
                  {transaction?.reference || '-'}
                </td>
                <td className={`p-4 pl-0 text-tiny text-body `}>
                  <div
                    className={`uppercase py-1 px-2 text-xs font-medium ${
                      getStatusTextAndStyles(transaction?.status?.toLowerCase())
                        ?.solid
                    } rounded-full flex items-center w-fit`}
                  >
                    {transaction?.status || '-'}
                  </div>
                </td>
                <td className="p-4 pl-0 text-tiny text-body">
                  {moment(transaction?.createdAt).format('Do MMM, YYYY h:m a')}
                </td>

                <td className="p-4 pl-0">
                  {/*<button>*/}
                  {/*  <img src={eye} alt="" width={16} height={16} />*/}
                  {/*</button>*/}
                </td>
              </tr>
            ))}
          </tbody>
        </TableLayout>
      </div>
    </BillingsLayout>
  );
}

export default ProfiledRiskBillings;
